import { Component } from 'preact'
import { z } from 'zod'
// eslint-disable-next-line import/no-internal-modules
import {
  widgetContainerConfig
  // eslint-disable-next-line import/no-internal-modules
} from '../../../../preact-components/widget-container'
// eslint-disable-next-line import/no-internal-modules
import FeaturedTopicsWidget from '@insided/destination/modules/Navigation/widget-featured-topics/index.sync'
// eslint-disable-next-line import/no-internal-modules
import { AnyFeaturedTopic } from '@insided/destination/modules/Navigation/widget-featured-topics/types'

interface DynamicContentWidgetProps {
  config: DynamicContentConfig
  dynamicContentData: AnyFeaturedTopic[]
}

export const widgetName = 'dynamic_content'

export const config = z
  .object({
    buttonURL: z.string(),
    buttonLabel: z.string(),
    maxNumberOfItems: z.number(),
    selectedContentType: z.enum(['all', 'article', 'conversation', 'question', 'idea', 'productUpdate']),
    selectedSortType: z.enum(['lastActivityAt', 'replyCount', 'views'])
  })
  .merge(widgetContainerConfig)

export type DynamicContentConfig = z.infer<typeof config>

export default class DynamicContentWidget extends Component<DynamicContentWidgetProps> {
  render() {
    const { config } = this.props

    return (
      <FeaturedTopicsWidget
        config={{
          topics: [],
          buttonURL: config.buttonURL,
          buttonLabel: config.buttonLabel,
          firstTopicsNumber: 0,
          title: config.title,
          subtitle: config.subtitle,
          backgroundColor: config.backgroundColor,
          backgroundColorDisplay: config.backgroundColorDisplay
        }}
        widgetName='dynamic-content'
        featuredTopics={this.props.dynamicContentData}
      />
    )
  }
}
